import 'css-chunksrc/client/scenes/calendar/creationMenu/styles.scss';export default {
  "creationMenu": "_creationMenu_1d484_1",
  "button": "_button_1d484_5",
  "icon": "_icon_1d484_25",
  "iconBox": "_iconBox_1d484_33",
  "menu": "_menu_1d484_42",
  "menuItem": "_menuItem_1d484_54",
  "menuText": "_menuText_1d484_67"
};